import { ModalHeader } from '@chakra-ui/react';
import { OverviewChartConfiguration } from '@resistapp/client/utils/overview-chart-configurations';
import { NoticeIcon } from '../icons/notice-icon';
import { ReductionInfo } from '../modals/reduction/reduction-info';
import { oldTheme } from '../shared/old-styles';
import { MetricTitle } from '../shared/overview-metric-title';
import { InfoIconProps } from './info-icons-general';
import { MetricInfoIcon } from './metric-info-icon';

export function ReductionInfoIcon(props: InfoIconProps & { activeOverviewConfiguration?: OverviewChartConfiguration }) {
  const modalHeader = (
    <ModalHeader style={{ marginLeft: '-20px' }}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <NoticeIcon />
        <div style={{ paddingLeft: oldTheme.spacing.xs }}>
          <MetricTitle noBold noColor />
        </div>
      </div>
    </ModalHeader>
  );

  const modalContent = (
    <>
      {modalHeader}
      <ReductionInfo />
    </>
  );

  return <MetricInfoIcon {...props} modalContent={modalContent} />;
}
